import { X, Edit2 } from "lucide-react";

export const EditHistoryModal = ({ editHistModal, setEditHistModal }) => {
  if (!editHistModal.open) return null;
  const doc = editHistModal.doc;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="edit-history-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-5 space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-bold text-base">Edit history</h3>
            <p className="text-xs muted mt-0.5">{doc?.serial} · {doc?.client_name}</p>
          </div>
          <button
            onClick={() => setEditHistModal({ open: false, doc: null })}
            className="text-slate-400 hover:text-slate-600"
            data-testid="edit-history-close"
          >
            <X size={16} />
          </button>
        </div>
        {(doc?.edit_history || []).length === 0 ? (
          <p className="text-sm muted py-4" data-testid="edit-history-empty">
            No edits recorded yet.
            {doc?.last_edited_by
              ? ` Last edited by ${doc.last_edited_by}${doc.updated_at ? ` on ${new Date(doc.updated_at).toLocaleString()}` : ""} (before change tracking was enabled).`
              : ""}
          </p>
        ) : (
          <div className="divide-y divide-slate-100 max-h-80 overflow-y-auto">
                {[...(editHistModal.doc.edit_history || [])].reverse().map((e, i) => (
                  <div key={`${e.at || ""}-${e.by || ""}-${i}`} className="py-2.5 text-sm" data-testid={`edit-history-entry-${i}`}>
                <div className="flex items-center gap-2">
                  <Edit2 size={13} className="text-[#0e6939] shrink-0" />
                  <span className="font-semibold">{e.by}</span>
                  <span className="text-xs muted">{e.at ? new Date(e.at).toLocaleString() : ""}</span>
                </div>
                <div className="mt-1 pl-5 space-y-0.5">
                  {Object.entries(e.changes || {}).map(([field, ch]) => (
                    <div key={field} className="text-xs">
                      <span className="font-medium capitalize">{field.replace(/_/g, " ")}</span>:{" "}
                      <span className="muted line-through break-all">{String(ch.from ?? "") || "(empty)"}</span>
                      {" → "}
                      <span className="text-slate-800 break-all">{String(ch.to ?? "") || "(empty)"}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
